import React from 'react';
import { IDropdownOption, Stack, Separator, getTheme } from '@fluentui/react';
import { TooltipText } from '../../shared';
import { ConfigDropdown } from '../rules';
import { ConfigCheckbox } from './ConfigCheckbox';
import { AdminContext } from 'Store/Admin';
import { ConfigCaseField } from './ConfigCaseField';
import { FieldSectionComponent } from '../FieldSectionComponent';
import { separatorStyle } from '../SettingsStyles';

export const optionsCaseComparerAlgorithm: IDropdownOption[] = [
  { key: 'SourceWeight', text: 'Source Weight' },
  { key: 'SourceWeightRate', text: 'Source Weight Rate' },
  { key: 'CaseCreation', text: 'Case Creation' }
];

export const Cases: React.FunctionComponent = () => {
  const { palette } = getTheme();

  const { state } = React.useContext(AdminContext);

  return (
    <div className="ms-grid-row mb-4">
      <FieldSectionComponent
        title={TooltipText.subtitleCasesPerSet}
        body={TooltipText.configDefaultMaxAssignedCaseCount}
      >
        <Stack.Item className="position-relative">
          <ConfigCaseField tooltip={''} id="defaultMaxAssignedCaseCount" label="" />
        </Stack.Item>
      </FieldSectionComponent>

      <Separator styles={separatorStyle(palette)} />

      <FieldSectionComponent
        id={'optionalFeedbackCommentTitle'}
        title={TooltipText.subtitleAllowEmptyCommentsField}
        body={TooltipText.configModeratorFeedbackCommentOptional}
      >
        <Stack.Item>
          {state.queueDataState && (
            <ConfigCheckbox
              className="text-center ms-Grid-col ms-sm12 ms-md12 font-weight-bold"
              tooltip={''}
              id="moderatorFeedbackCommentOptional"
              label="Allow"
              describedBy="optionalFeedbackCommentTitle"
              value={state.queueDataState.moderatorFeedbackCommentOptional}
            />
          )}
        </Stack.Item>
      </FieldSectionComponent>
      <Separator styles={separatorStyle(palette)} />

      <FieldSectionComponent title={TooltipText.subtitleSorting} body={TooltipText.configDefaultCaseComparerAlgorithm}>
        <Stack.Item>
          <ConfigDropdown
            className="ms-md12"
            tooltip={''}
            id="defaultCaseComparerAlgorithm"
            label="Sort by"
            options={optionsCaseComparerAlgorithm}
          />
        </Stack.Item>
      </FieldSectionComponent>
    </div>
  );
};
